export enum UserConsentType {
  NotGivenYet = 0,
  Agreed = 1,
  NotAgreed = 2
}
